import React, { useEffect, useMemo, useState } from "react"

import { AppError } from "../errors/errorProcessors"

interface IUseGetDeviceFormDataFromApiResponseOutput<T> {
    formData: T
    setFormData: React.Dispatch<React.SetStateAction<T>>
}

const useGetDeviceFormDataFromApiResponse = <T, R>(
    mapper: (response: T) => R,
    emptyMapper: () => R,
    isLoading: boolean,
    isValidating: boolean,
    error?: AppError,
    response?: T
): IUseGetDeviceFormDataFromApiResponseOutput<R> => {
    const dataIsValid = !isValidating && !isLoading && !error && !!response

    const defaultFormData = useMemo(
        () => (dataIsValid ? mapper(response) : emptyMapper()),
        [response, dataIsValid, emptyMapper, mapper]
    )

    const [formData, setFormData] = useState<R>(defaultFormData)

    useEffect(() => {
        setFormData(defaultFormData)
    }, [defaultFormData, setFormData])

    return {
        formData,
        setFormData,
    }
}

export default useGetDeviceFormDataFromApiResponse
